import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Mosquito = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49v-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3v-.3l133.4 121.8c57 59.8 154.6 17.4 154.6-67.2 0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8l-23.8-41.7 38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2l22.7 39.4-50.2 50.3v-38.2c0-14.9-10.2-27.4-24-31V63.9c0-4.4-3.6-8-8-8s-8 3.6-8 8v57.2c-13.8 3.6-24 16.1-24 31v38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1L211.4 90l-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266v.3l-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1v54.7l-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1v-55.4l24.3-31.6v63.1c0 17.7 14.3 32 32 32s32-14.3 32-32v-63.1l24.3 31.6v55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
  }));
});
Mosquito.displayName = 'Mosquito';
export var MosquitoDimensions = {
  height: 512,
  width: 640
};